<template>
  <div class="ljb-item-margin-top">
    <module-title :module-title="moduleTitle"/>
    <product-list
      :list="list"
      :start-margin="false"/>
  </div>
</template>
<script>
import SwipeActive from '../swiper/SwipeActive'
import TimeCard from './TimeCard'
import {mapGetters} from 'vuex'
import ModuleTitle from '@/components/title/ModuleTitle'
import ProductList from './ProductList'
let page = 1
export default {
  name: 'CardItems',
  components: {ProductList, TimeCard, SwipeActive, ModuleTitle},
  data () {
    return {
      list: [
      //   {
        //   img: 'https://cdn.51ljb.cn/ljb-card_pa_gold.png',
      //   name: 'VIP私人律师金卡',
      //   text: '0.3元/天、电话咨询不限次、见面咨询七折',
      //   price: '120',
      //   originalPrice: '1000',
      //   tag: '12.12',
      //   url: 'go_MemberCard/MC19001'
      // }, {
      //   img: 'https://cdn.51ljb.cn/ljb-card_pa_platinum.png',
      //   name: 'VIP私人律师白金卡',
      //   text: '文书审查、发律师函、代打官司',
      //   price: '3000',
      //   originalPrice: '3000',
      //   url: 'go_MemberCard/MC19002'
      // }, {
      //   img: 'https://cdn.51ljb.cn/ljb-card_pa_single.png',
      //   name: '律师咨询次卡',
      //   text: '法律问题按次电话咨询、不限时长',
      //   price: '49',
      //   originalPrice: '80',
      //   url: 'go_TimesCard/PC15001'
      // }, {
      //   img: 'https://cdn.51ljb.cn/ljb-card_pa_timcard.png',
      //   name: '律师咨询时长卡',
      //   text: '抵扣咨询时长',
      //   price: '38',
      //   originalPrice: '60',
      //   url: 'go_TimeCard'
      // }
      ],
      page: 1
    }
  },
  computed: {
    ...mapGetters('Channel', [
      'getChannelData'
    ]),
    banners () {
      if (this.getChannelData && this.getChannelData.banners) {
        let banners = this.getChannelData.banners.filter((item) => {
          if (item.bannerPlace === this.$dataResource.bannerType.header || item.bannerPlace === this.$dataResource.bannerType.header + '') return false
        })
        if (banners.length < 1) {
          banners = false
        }
        return banners
      }
      return false
    },
    moduleTitle () {
      return {
        title: '购卡专区',
        text: ''
      }
    }
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    byCard (item) {
      this.$utils.checkCanGoRouter(item.url)
    },
    getData () {
      this.$post.getRecommendProducts({
        page: page
      }).then((res) => {
        this.list = res.data
      })
    }

  }
}
</script>

<style scoped lang="scss">
  .item {
    @extend .ljb-size100;
    overflow: hidden;

  }

  .card-img {
    width: 128px;
    height: 85px;
    float: left;
  }

  .card-item {
    float: left;
    padding-left: 9px;
    height: 100%;
  }

  .card-price {
    /*margin-top: 6px;*/
    color: $price-color;
    font-size: 14px;
    /*font-weight: 600;*/
    font-weight: 600;
  }

  .text {
    max-lines: 2;
    max-width: 210px;
    height: 34px;
    font-size: 11px;
    @extend .ljb-md-hint-text;
    @extend .ljb-line-height20
  }

  .line {
    height: 0.5px;
    background-color: #eeeeee;
    margin-top: $padding;
    margin-left: 9px;
  }
  .card-title{
    font-size: 17px;
    align-items: center;
    align-content: center;
    @extend .ljb-line-height20;
    @extend .ljb-title;
    @extend .ljb-flex-row;
    @extend .ljb-flex-row;
  }
  .card-sp{
    padding-left: 9px;
    font-size: 11px;
    @extend .ljb-md-hint-text;
    text-decoration:line-through;
  }
  .card-tag{
    margin: auto 6px auto 0;
    /*height: 16px;*/
    padding: 0 4px;
    opacity: 0.8;
    font-family: "PingFangSC-Regular";
    background-color: $price-color;
    font-size: 10px;
    color: white;
    @extend .double-center
    /*line-height: 16px;*/
  }
  .item-margin-top{
    margin-top: $padding;
  }
  .base{
    padding-left: 9px;
    padding-right: $padding;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/CardList.vue